import React from 'react';
import { Link } from 'react-router-dom';

import { IMAGES } from '../../enum';
import LinkText from '../Text/LinkText';

const TextWithExternalLink = props => {
  const { text, linkProps, textProps } = props;

  const LinkWrapper = linkProps?.href ? React.Fragment : Link;
  const normalizedLinkProps = linkProps?.href ? { href: linkProps?.href } : { to: linkProps?.to };

  return (
    <LinkWrapper {...normalizedLinkProps} target="_blank" rel="noopener noreferrer">
      <LinkText
        renderAs="a"
        {...normalizedLinkProps}
        size={linkProps?.size}
        style={{
          display: 'flex',
          width: '100%',
          maxWidth: 'max-content',
          align: 'center',
          gap: '5px',
        }}
      >
        <span {...textProps}>{text}</span>

        <img
          width="14px"
          src={IMAGES.EXPAND_WINDOW_ICON}
          alt="open in new window"
          style={{ display: 'flex' }}
        />
      </LinkText>
    </LinkWrapper>
  );
};

TextWithExternalLink.defaultProps = {
  linkProps: {},
  textProps: {},
};

export default TextWithExternalLink;
